import React from 'react';
import { TailwindTooltip } from '~/libs/ui/atoms/TailwindTooltip';

export interface TruncatedTextProps {
	text: string;
	className?: string;
	expanded?: boolean;
	tooltipPosition?: 'left' | 'right' | 'top' | 'bottom';
}

export function TruncatedText({
	text,
	className = '',
	expanded = false,
	tooltipPosition = 'bottom',
}: TruncatedTextProps) {
	if (!text) {
		return null;
	}

	if (expanded) {
		return <span className={`block min-w-0 whitespace-normal break-words ${className}`}>{text}</span>;
	}

	return (
		<TailwindTooltip
			reference={
				<span className={`block min-w-0 truncate ${className} focus:outline-none`} tabIndex={0}>
					{text}
				</span>
			}
			displayClass='block min-w-0 max-w-full'
			position={tooltipPosition}
			maxWidthClass='max-w-md'
		>
			{text}
		</TailwindTooltip>
	);
}
